import React from 'react';
import { NavWrapper, NavSite } from './Navigation.style';
import { NavLink } from 'react-router-dom';
import ButtonContact from 'components/atoms/button/ButtonContact';
import styled from 'styled-components';
import EleAnimatedButtonAboutUs from 'components/atoms/button/Electromobility/EleAnimatedButtonAboutUs';
import EleAnimatedButtonOffer from 'components/atoms/button/Electromobility/EleAnimatedButtonOffer';
import EleAnimatedButtonContact from 'components/atoms/button/Electromobility/EleAnimatedButtonContact';
import EleAnimatedButtonIndustry from 'components/atoms/button/Electromobility/EleAnimatedButtonIndustry';
import EleSidebar from '../sidebar/EleSidebar';
import EleAnimatedButtonToEle from 'components/atoms/button/Electromobility/EleAnimatedButtonToEle';
import EleAnimatedButtonToProject from 'components/atoms/button/Electromobility/EleAnimatedButtonToProject';

const StyledLink = styled(NavLink).attrs({ activeClassName: 'active-link' })`
  text-decoration: none;
  color: black;
  &:hover {
    text-decoration: none;
  }
  &:visited {
    color: black;
    /* color: white; */
  }

  &.active-link {
    border-bottom: black 1px solid;
    padding-bottom: 5px;
  }
`;

const EleNavigation = () => (
  <>
    <NavWrapper>
      <EleAnimatedButtonToEle />
      <EleAnimatedButtonToProject />
      <EleAnimatedButtonAboutUs />
      <EleAnimatedButtonOffer />
      <EleAnimatedButtonContact />
      {/* <EleAnimatedButtonIndustry /> */}
    </NavWrapper>
    <EleSidebar />
  </>
);

export default EleNavigation;
